var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 13.5827C7.66667 13.5827 9.16667 12.0577 9.16667 10.2077C9.16667 9.24102 8.69167 8.32435 7.74167 7.54935C6.79167 6.77435 6.075 5.62435 5.83333 4.41602C5.59167 5.62435 4.88333 6.78268 3.925 7.54935C2.96667 8.31602 2.5 9.24935 2.5 10.2077C2.5 12.0577 4 13.5827 5.83333 13.5827Z",
    stroke: "black",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4659 5.50091C11.039 4.58518 11.4453 3.57511 11.6659 2.51758C12.0826 4.60091 13.3326 6.60091 14.9992 7.93425C16.6659 9.26758 17.4992 10.8509 17.4992 12.5176C17.504 13.6695 17.1666 14.7969 16.5299 15.7568C15.8932 16.7168 14.9857 17.466 13.9227 17.9097C12.8596 18.3533 11.6887 18.4713 10.5585 18.2486C9.42832 18.026 8.38966 17.4729 7.57422 16.6592",
    stroke: "black",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkinIcon);
export default __webpack_public_path__ + "static/media/skin-icon.5ba4391c718a5ca6b684b610cfddf930.svg";
export { ForwardRef as ReactComponent };